/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

/** Common Components */
import ToastService from '../../../../../../../services/toastService/ToastService';
import Buttons from '../../../../../../../components/ui/button/Buttons';
import CustomCenterModel from '../../../../../../../components/ui/customCenterModel/CustomCenterModel';
import FormInputFields from '../../../../../../../components/finalForms/formFields/FormInputFields';
import { AppIcons } from '../../../../../../../data/appIcons';
import MolGrid, { Column } from "@moltech/molui/molgrid";
import FormSelectField from '../../../../../../../components/finalForms/formFields/FormSelectField';
import CardSection from '../../../../../../../components/ui/card/CardSection';

/** RTK Query */
import { useAddUpdateContractCoverageCountMutation, useDeleteContractCoverageCountMutation, useLazyGetAllContractCoverageCountsQuery, useLazyGetInstrumentTypesForContractQuery } from '../../../../../../../app/services/contractAPI';

const CoverageCounts = (props) => {

  const [isModelOpen, setIsModelOpen] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [instrumentTypes, setInstrumentTypes] = useState([]);
  const [selectedInstrumentTypes, setSelectedInstrumentTypes] = useState();
  const [plCount, setPlCount] = useState(1);
  const [rowData, setRowData] = useState(null);
  const [contractCoverageCountKey, setContractCoverageCountKey] = useState(null);


  const [getAllContractCoverageCounts, {
    isFetching: isAllContractCoverageCountsFetching,
    isSuccess: isAllContractCoverageCountsFetched,
    data: AllContractCoverageCountsData,
  }] = useLazyGetAllContractCoverageCountsQuery();

  const [getInstrumentTypesForContract, {
    isFetching: isInstrumentTypesForContractFetching,
    isSuccess: isInstrumentTypesForContractFetched,
    data: InstrumentTypesForContractData,
  },] = useLazyGetInstrumentTypesForContractQuery();


  const [deleteContractCoverageCount, {
    isSuccess: isdeleteContractCoverageCountDeleted,
    data: deleteContractCoverageCountData
  }] = useDeleteContractCoverageCountMutation();

  const [addUpdateContractCoverageCount, {
    isSuccess: isaddUpdateContractCoverageCountAdded,
    data: addUpdateContractCoverageCountData,
  },] = useAddUpdateContractCoverageCountMutation();

  useEffect(() => {
    getAllContractCoverageCounts(props.contractId);
    getInstrumentTypesForContract(props.contractId, "");
  }, [props.contractId, rowData]);

  useEffect(() => {
    if (!isInstrumentTypesForContractFetching && isInstrumentTypesForContractFetched && InstrumentTypesForContractData) {
      let options = InstrumentTypesForContractData.map(item => ({ value: item.sInstrumentType, label: item.sInstrumentType }));
      if (rowData) {
        setInstrumentTypes([...options, { value: rowData?.coverageType, label: rowData?.coverageType }]);
      }
      else {
        setInstrumentTypes(options);
      }
    }
  }, [isInstrumentTypesForContractFetching, isInstrumentTypesForContractFetched, InstrumentTypesForContractData])


  useEffect(() => {
    if (!isAllContractCoverageCountsFetching && isAllContractCoverageCountsFetched && AllContractCoverageCountsData) {
      setGridData(AllContractCoverageCountsData);
    }
  }, [isAllContractCoverageCountsFetching, isAllContractCoverageCountsFetched, AllContractCoverageCountsData])

  useEffect(() => {
    if (isaddUpdateContractCoverageCountAdded && addUpdateContractCoverageCountData) {
      if (addUpdateContractCoverageCountData) {
        ToastService.success(addUpdateContractCoverageCountData?.errorMessage);
        handleCloseModel();
        getAllContractCoverageCounts(props.contractId);
        setInstrumentTypes([]);
        getInstrumentTypesForContract(props.contractId, "");
      }
    }
  }, [isaddUpdateContractCoverageCountAdded, addUpdateContractCoverageCountData]);

  useEffect(() => {
    if (isdeleteContractCoverageCountDeleted && deleteContractCoverageCountData) {
      if (deleteContractCoverageCountData) {
        ToastService.success(deleteContractCoverageCountData?.errorMessage);
        getAllContractCoverageCounts(props.contractId);
        setInstrumentTypes([]);
        getInstrumentTypesForContract(props.contractId, "");
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
  }, [isdeleteContractCoverageCountDeleted, deleteContractCoverageCountData]);

  const handleCloseModel = () => {
    setIsModelOpen(false);
    setRowData(null);
    setSelectedInstrumentTypes(null);
    setPlCount(1);
    setContractCoverageCountKey(null);
  }

  const handleRowData = (row) => {
    setIsModelOpen(true);
    setSelectedInstrumentTypes({ value: row?.coverageType, label: row?.coverageType });
    setRowData(row);
    setPlCount(row?.countPerContract);
    setContractCoverageCountKey(row?.lContractCoverageCountKey);
  }

  const handaleSave = () => {
    if (!selectedInstrumentTypes) {
      ToastService.error("Instrument Type is required");
      return;
    }
    const req = {
      plContractKey: props.contractId,
      plContractCoverageCountKey: contractCoverageCountKey || 0,
      psRigidOrFlexible: selectedInstrumentTypes?.value,
      plCount: plCount
    }
    addUpdateContractCoverageCount(req);
  }

  const handaleCountChange = (dataField, value) => {
    setPlCount(value);
  }

  const handleDropdownChange = (dataField, selectedOption) => {
    setSelectedInstrumentTypes(selectedOption);
  }

  const getCtxMenuItems = (row) => {
    if (!row) return [];
    return [
      {
        label: 'Edit Coverage Type',
        command: () => { handleRowData(row) }
      },
      {
        label: 'Delete Coverage Type',
        command: () => {
          if (row?.lContractCoverageCountKey) {
            deleteContractCoverageCount(row?.lContractCoverageCountKey);
          }
        }
      }
    ];
  }

  return (
    <div>
      <div className="scrollable-grid">
        {
          !props.isUnlimitedProducts && (
            <CardSection
              cardTitle={"Coverage Counts"}
              rightButton={true}
              isButtonVisible={true}
              buttonClassName="btn blue-btn w-full"
              titleButtonClick={() => setIsModelOpen(true)}
              buttonText="Add"
            >
              <MolGrid
                value={gridData}
                grouping
                expandableRowGroups={true}
                paginator={false}
                scrollable
                scrollHeight="flex"
                filterDisplay="row"
                sortMode="single"
                showGridlines
                resizableColumns
                ctxMenuItems={getCtxMenuItems}
              >
                <Column field="coverageType" header="Coverage Type" grouping sortable bodyStyle={{ textAlign: "center" }} />
                <Column field="countPerContract" header="Count Per Contract" grouping sortable bodyStyle={{ textAlign: "center" }} />
                <Column field="actualCount" header="Actual Count" grouping sortable bodyStyle={{ textAlign: "center" }} />
              </MolGrid>
            </CardSection>
          )
        }
      </div>
      <div>
        <CustomCenterModel
          isOpen={isModelOpen}
          useCustomBg={true}
          modalTitle={`${rowData ? "Edit" : "Add"} Contract Coverage Count`}
          contentClass="content-35"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
        >
          <div className="row mb-2">
            <FormSelectField
              fieldSetting={
                { options: instrumentTypes, placeholder: "Select Instrument Type" }
              }
              options={instrumentTypes}
              value={selectedInstrumentTypes}
              onChange={handleDropdownChange}
              labelName="Instrument Type :"
              isRequired={true}
            />
          </div>
          <FormInputFields
            dataField="plCount"
            value={plCount}
            labelName="Count"
            isRequired={true}
            type="number"
            name="Enter Count"
            onChange={handaleCountChange}
            error={plCount <= 0 ? 'Count is required and should be greater than 0' : ''}
          />
          <div className="d-flex justify-content-center button-submit mt-3">
            <Buttons
              buttonText="Save"
              buttonTypeClassName="btn blue-btn w-full"
              onClick={handaleSave}
            // isDisable={!isEditContract}
            />
            <Buttons
              buttonText="Cancel"
              buttonTypeClassName="btn secondary-btn ml-4"
              onClick={handleCloseModel}
            />
          </div>
        </CustomCenterModel>
      </div>
    </div>
  )
}
export default CoverageCounts